import styled from "styled-components";

export const Container = styled.iframe`
  min-height: 480px;
  width: 100%;
`;
